import { AppShell, Box, Group, Image, rem, Title, useMantineTheme } from "@mantine/core";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { logoMaxSize } from "routes/account/route";
import { customerQueryOptions } from "shared/graphql/customer";
import { useColorMode } from "shared/hooks/useColorMode";
import { useIsMobile } from "shared/hooks/useIsMobile";

const Page = () => {
    const {
        data: { customer },
    } = useSuspenseQuery(customerQueryOptions.whiteLabeling);

    const isMobile = useIsMobile();
    const theme = useMantineTheme();
    const { isDark } = useColorMode();

    return (
        <AppShell header={{ height: rem(60) }}>
            <AppShell.Header>
                <Group h="100%" px="md" wrap="nowrap">
                    <Group pl="xs">
                        <Image
                            src={`${import.meta.env.VITE_API_BASE_URL}/customers/${customer.id}/icon`}
                            fallbackSrc={"/bryx.svg"}
                            style={{ maxWidth: logoMaxSize, maxHeight: logoMaxSize }}
                        />
                        <Title order={2} fw={"light"} lineClamp={1}>
                            {customer.name}
                        </Title>
                    </Group>
                </Group>
            </AppShell.Header>
            <AppShell.Main
                style={{
                    height: isMobile ? "calc(100dvh - 116px)" : "92dvh",
                    maxHeight: isMobile ? "calc(100dvh - 116px)" : "92dvh",
                    background: isDark ? theme.colors.dark[6] : theme.colors.gray[2],
                }}
            >
                <Box w="100%" h="100%" style={{ overflowY: "auto" }}>
                    <Outlet />
                </Box>
            </AppShell.Main>
        </AppShell>
    );
};

/** @public */
export const Route = createFileRoute("/unsubscribe")({
    component: Page,
});
